<script setup>
import { ref, onMounted } from 'vue';
import { useLayout } from '@/layout/composables/layout';
import AccountUser from '../views/Account.vue';
import { useConfirm } from "primevue/useconfirm";
import { callAPI, DRUPAL_API_ROUTE } from "../service/DrupalService";
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const { toggleMenu } = useLayout();
const confirm = useConfirm();
const homepage = import.meta.env.VITE_DRUPAL_URL;

const drawerVisibleAccount = ref(false);
const currentWorkspace = ref();
const user = ref(JSON.parse(localStorage.getItem('user')));
const workspaces = ref(JSON.parse(localStorage.getItem('workspaces')));

function openDrawerAccount() {
  drawerVisibleAccount.value = true;
}

function updateDrawerVisibilityAccount(value) {
  drawerVisibleAccount.value = value;
}

const getCurrentWorkspace = () => {
  return workspaces.value.find(w => w.id == user.value.current_workspace);
};

const workspaceSwitchConfirm = () => {
  confirm.require({
    message: t('workspaces.workspace.change'),
    header: t('workspaces.workspace.title'),
    icon: 'pi pi-question-circle',
    rejectProps: {
      label: t('common.labels.cancel'),
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'OK'
    },
    accept: async () => {
      await callAPI(DRUPAL_API_ROUTE.WORKSPACE_CURRENT, {}, { workspace: currentWorkspace.value.id });
      location.reload();
    },
    reject: () => {
      currentWorkspace.value = getCurrentWorkspace();
    }
  });
}

onMounted(() => {
  currentWorkspace.value = getCurrentWorkspace();
});


</script>

<template>
  <AccountUser :visible="drawerVisibleAccount" @update:visible="updateDrawerVisibilityAccount" />
  <div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button class="layout-menu-button layout-topbar-action" @click="toggleMenu">
        <i class="pi pi-bars"></i>
      </button>
      <a :href="homepage" title="Retour au site">
        <img src="@/assets/images/lccx_nemorius.png" class="w-48">
      </a>
    </div>
    <div class="flex space-x-6 ml-auto mr-2 max-w-[30%]">
      <Select @change="workspaceSwitchConfirm" v-model="currentWorkspace" filter :options="workspaces"
        optionLabel="name" class="w-full md:w-56">
        <template #value="slotProps">
          <div v-if="slotProps.value" class="flex items-center">
            <img :src="slotProps.value.logo" class="mr-4 w-10" />
            <div>{{ slotProps.value.name }}</div>
          </div>
        </template>
        <template #option="slotProps">
          <div class="flex items-center">
            <img :src="slotProps.option.logo" class="mr-2 w-6" />
            <div>{{ slotProps.option.name }}</div>
          </div>
        </template>
        <template #dropdownicon>
          <i class="pi pi-arrow-circle-down" />
        </template>
      </Select>
    </div>
    <div class="layout-topbar-actions !ml-0">

      <button class="layout-topbar-menu-button layout-topbar-action"
        v-styleclass="{ selector: '@next', enterFromClass: 'hidden', enterActiveClass: 'p-anchored-overlay-enter-active', leaveToClass: 'hidden', leaveActiveClass: 'p-anchored-overlay-leave-active', hideOnOutsideClick: true }">
        <i class="pi pi-ellipsis-v"></i>
      </button>

      <div class="layout-topbar-menu hidden lg:block">
        <div class="layout-topbar-menu-content">
          <button @click="openDrawerAccount" type="button" class="layout-topbar-action">
            <i class="pi pi-user"></i>
            <span>{{ t('account.title') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
